import React from 'react'
import db from '../db'
import Layout from '../Layouts/Layout'
import { Link } from 'react-router-dom'
import WeAreHere from '../Components/WeAreHere'
import { Helmet } from 'react-helmet-async'

export default function Services () {
  return (
    <Layout>
      <Helmet>
        <title>Xidmətlər | Kodart Tətbiq və Təlim Mərkəzi</title>
        <meta name="description" content="Kodart Tətbiq və Təlim Mərkəzinin proqram təminatı xidmətləri: veb saytlar, xüsusi biznes həlləri və konsaltinq." />
        <link rel="canonical" href="https://kodart.az/xidmətlər" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="az_AZ" />
        <meta property="og:url" content="https://kodart.az/xidmətlər" />
        <meta property="og:title" content="Xidmətlər | Kodart" />
        <meta property="og:description" content="Kodart Tətbiq və Təlim Mərkəzinin proqram təminatı xidmətləri: veb saytlar, xüsusi biznes həlləri və konsaltinq." />
        <meta property="og:image" content="https://kodart.az/android-chrome-512x512.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Xidmətlər | Kodart" />
        <meta name="twitter:description" content="Kodart Tətbiq və Təlim Mərkəzinin proqram təminatı xidmətləri: veb saytlar, xüsusi biznes həlləri və konsaltinq." />
        <meta name="twitter:image" content="https://kodart.az/android-chrome-512x512.png" />
      </Helmet>
      <main data-page='services'>
        <section className='section-container services-section'>
          <div className='section-header'>
            <h1>Xidmətlərimiz</h1>
            <div className='green-dot-line'></div>
          </div>
          <div className='row'>
            {db.solutions.map(c => {
              return (
                <div key={c.id || 0} className='col-12 col-lg-4'>
                  <div className='service-card'>
                    <h2>{c.title}</h2>
                    <img className='service-icon' src={c.image || ''} alt={c.description}/>
                    <p className='service-description'>{c.description}</p>
                    <Link to={`tel:+994509920010`} className='lets-talk-button'>
                      <img src='./Images/Icons/phone.svg' alt={c.description}/>
                      <span>Gəlin, danışaq</span>
                    </Link>
                  </div>
                </div>
              )
            })}
          </div>
        </section>
        <WeAreHere/>
      </main>
    </Layout>
  )
}
